module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ui label",
    class: _vm.colorClass
  }, [_vm._v("Cena: "), (_vm.hasSale(_vm.item)) ? _c('span', {
    staticClass: "old-price-text"
  }, [_vm._v(_vm._s(_vm.realOldPrice(_vm.item)) + " €")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realPrice(_vm.item)) + " €")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09f2e2ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Price.vue
// module id = 319
// module chunks = 1